import { computed, toValue, type MaybeRefOrGetter, type ComputedRef } from "vue";
import { getApiUrl } from "@/data/constants";
import { useApiStore } from "@/stores/api";
import { useDevicePixelRatio } from "@vueuse/core";

export function buildImageUrl(
  uuid: string,
  imagesToken: string,
  size?: [number, number],
  pixelRatio = 1,
): string {
  let sizeSegment = "";
  if (size !== undefined) {
    const [w, h] = [size[0] * pixelRatio, size[1] * pixelRatio];
    sizeSegment = `thumbs/${w}x${h}/`;
  }
  return `${getApiUrl()}/serve/${sizeSegment}${uuid}?images_token=${imagesToken}`;
}

export function useImageUrl(
  uuid: MaybeRefOrGetter<string>,
  size?: MaybeRefOrGetter<[number, number] | undefined>,
  pixelRatioOverride?: MaybeRefOrGetter<number | undefined>,
): ComputedRef<string> {
  const api = useApiStore();
  const { pixelRatio: browserPixelRatio } = useDevicePixelRatio();

  return computed(() =>
    buildImageUrl(
      toValue(uuid),
      api.imagesToken,
      toValue(size),
      toValue(pixelRatioOverride) ?? browserPixelRatio.value,
    )
  );
}
